module.exports = __webpack_public_path__ + "img/mobile-picking-profile.df69b55e.svg";